import React from "react";
import { useSelector } from "react-redux";

export const VideoBackground = () => {
  const trailer = useSelector((state) => state.movies.mainTrailer);
  if (trailer === undefined || trailer === null) {
    return;
  }
  const trailerUrl = `https://www.youtube.com/embed/${trailer.key}?controls=0&autoplay=1&mute=1&loop=1&playlist=${trailer.key}`;
  return (
    <div className="w-screen aspect-video">
      <iframe
        className="w-screen aspect-video"
        src={trailerUrl}
        title="YouTube video player"
        allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
      ></iframe>
    </div>
  );
};
